import {configureStore} from '@reduxjs/toolkit'
import notificationBannerReducer from './slices/notificationBannerSlice'
import percentagePopupReducer from './slices/percentagePopupSlice'
import configReducer from './slices/configSlice'
import userFeedbackReducer from './slices/userFeedbackSlice'
import filtersReducer from './slices/filtersSlice'
import globalSearchReducer from './slices/globalSearchSlice'
import personaReducer from './slices/personaSlice'
import personaQueryReducer from './slices/personaQuerySlice'
import outreachSimulationFilterReducer from './slices/outreachSimulationFilterSlice'
import expiringUserReducer from './slices/expiringUserSlice'
import mapReducer from './slices/mapSlice'
import useCaseReducer from './slices/useCaseSlice'
import exportReducer from './slices/exportSlice'
import filterListDetailReducer from './slices/filterListDetailSlice'
import permissionReducer from './slices/permissionSlice'
import pointOfInterestReducer from './slices/pointOfInterestSlice'
import breadCrumbsReducer from './slices/breadCrumbsSlice'
import sdohReducer from './slices/sdohSlice'
import personaMapDataReducer from './slices/personaMapDataSlice'
import focusLayerReducer from './slices/focusLayerSlice'
import totalUSPopulationReducer from './slices/totalUSPopulationSlice'
import populationAggregationReducer from './slices/populationAggregationSlice'
import uniqueAddressesCountReducer from './slices/uniqueAddressesCountSlice'
import tableViewReducer from './slices/tableViewSlice'
import geographicBoundaryReducer from './slices/geographicBoundarySlice'
import populationDistributionDimensionReducer from './slices/populationDistributionDimensionSlice'
import chartMarkerReducer from './slices/chartMarkerSlice'
import longitudinalStatesReducer from './slices/longitudinalStatesSlice'
import longitudinalRiskChartReducer from './slices/longitudinalRiskChartSlice'
import stateChartReducer from './slices/stateChartSlice'
import countyChartReducer from './slices/countyChartSlice'
import nationChartReducer from './slices/nationChartSlice'
import adminPermissionReducer from './slices/adminPermissionSlice'
import projectDetailsReducer from './slices/projectDetailsSlice'
import customSettingsReducer from './slices/customSettingsSlice'
import createProjectReducer from './slices/createProjectSlice'
import updateProjectReducer from './slices/updateProjectSlice'
import customDashboardViewReducer from './slices/customDashboardViewSlice'
import timeoutReducer from './slices/timeoutSlice'
import superAdminReducer from './slices/superAdminSlice'
import filterManagementReducer from './slices/filterManagementSlice'
import savedFilterReducer from './slices/savedFilterSlice'

// Root reducer configuration
export const rootReducer = {
  notificationBanner: notificationBannerReducer,
  percentagePopup: percentagePopupReducer,
  config: configReducer,
  userFeedback: userFeedbackReducer,
  filters: filtersReducer,
  globalSearch: globalSearchReducer,
  persona: personaReducer,
  personaQuery: personaQueryReducer,
  outreachSimulationFilter: outreachSimulationFilterReducer,
  expiringUser: expiringUserReducer,
  map: mapReducer,
  useCase: useCaseReducer,
  export: exportReducer,
  filterListDetail: filterListDetailReducer,
  permission: permissionReducer,
  pointOfInterest: pointOfInterestReducer,
  breadCrumbs: breadCrumbsReducer,
  sdoh: sdohReducer,
  personaMapData: personaMapDataReducer,
  focusLayer: focusLayerReducer,
  totalUSPopulation: totalUSPopulationReducer,
  populationAggregation: populationAggregationReducer,
  uniqueAddressesCount: uniqueAddressesCountReducer,
  tableView: tableViewReducer,
  geographicBoundary: geographicBoundaryReducer,
  populationDistributionDimension: populationDistributionDimensionReducer,
  chartMarker: chartMarkerReducer,
  longitudinalStates: longitudinalStatesReducer,
  longitudinalRiskChart: longitudinalRiskChartReducer,
  stateChart: stateChartReducer,
  countyChart: countyChartReducer,
  nationChart: nationChartReducer,
  adminPermission: adminPermissionReducer,
  projectDetails: projectDetailsReducer,
  customSettings: customSettingsReducer,
  createProject: createProjectReducer,
  updateProject: updateProjectReducer,
  customDashboardView: customDashboardViewReducer,
  timeout: timeoutReducer,
  superAdmin: superAdminReducer,
  filterManagement: filterManagementReducer,
  savedFilter: savedFilterReducer
}

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types that use Immer updater functions
        ignoredActions: [
          'sdoh/updateSdohDataImmer',
          'sdoh/updateSelectedOptionsImmer',
          'sdoh/updateToggleOptionsForExportImmer',
          'sdoh/updateRemovedAndResetFiltersImmer'
        ],
        // Ignore these paths in the state
        ignoredActionPaths: ['payload']
      }
    }),

  // DevTools enabled in development
  devTools: process.env.NODE_ENV !== 'production'
})

export default store
